import PaginationsContainer from "../../Componant/BonusUI/Paginations";

const Paginations = () => {
  return (
    <div className="page-body">
      <PaginationsContainer />
    </div>
  );
};

export default Paginations;
